import type {Theme, Components} from "@mui/material/styles";

type ListItemTextOverrides = Components<Theme>["MuiListItemText"];

const overrides: ListItemTextOverrides = {
    styleOverrides: {
        root: {},
        primary: ({theme}) => ({
            color: theme.color.text.default,
            fontWeight: theme.typography.fontWeight.medium,
        }),
        secondary: ({theme}) => ({
            color: theme.color.text.subtle,
        }),
    },
    defaultProps: {
        primaryTypographyProps: {variant: "title4", component: "span"},
        secondaryTypographyProps: {variant: "body4"},
    },
};

export default overrides;
